import React, { useCallback, useEffect } from 'react';

import {
    ActionIcon, Group, Stack, Title, Image,
} from '@mantine/core';
import { Link } from 'react-router-dom';

import PermissionManager from '../../blocks/PermissionManager';
import { hosts } from '../../const';

const PANEL_STYLE = {
    position: 'absolute',
    left: 0,
    bottom: 0,
    background: '#ffffff',
    width: '100%',
    borderTop: '1px solid #e9ecef',
};

function ProjectSelect({
    user, history, currentProject, setCurrentProject,
}) {
    useEffect(() => {
        if (
            !user?.permissions?.projects?.length
            || user.permissions.projects.includes(currentProject)
        ) {
            return;
        }

        setCurrentProject(user.permissions.projects[0]);
    }, [user]);

    const handleProjectChange = useCallback((event) => {
        const { project } = event.currentTarget.dataset;

        setCurrentProject(project);
    }, [history]);

    return (
        <Stack
            p="6px 18px"
            spacing={4}
            style={PANEL_STYLE}
        >
            <Title order={5}>Проекты</Title>
            <Group
                spacing={4}
                align="center"
            >
                {Object.entries(hosts).map(([project, projectInfo]) => (
                    <PermissionManager key={project} allowedProjects={[project]}>
                        <ActionIcon
                            component={Link}
                            to="/contentmanager/"
                            onClick={handleProjectChange}
                            data-project={project}
                        >
                            <Image
                                src={projectInfo?.icon}
                                width={20}
                            />
                        </ActionIcon>
                    </PermissionManager>
                ))}
            </Group>
        </Stack>
    );
}

export default ProjectSelect;
